/* --------------------------------------------------------------------------------------
   appSettings.const.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const appSettings = {
  appName: "Connect for Clio",
  //deviceUrl: "http://192.168.1.94",
  deviceUrl: 'http://127.0.0.1',
  deviceHost: 'http://localhost:8080',
  jobTemplateName: "clio.xst",
  primaryColor: "navy",
  emailRegex:
    /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
  api: "https://api.xeroxlegalpractice.com",
  devApis: {
    localhost: "http://localhost:56151",
    dev: "https://xeroxclio-dev.azurewebsites.net",
    test: "https://xeroxclio-test.azurewebsites.net",
    staging: "https://xeroxclio-staging.azurewebsites.net",
  },
  apiPath: "/api/v1",
  localhostApi: "test",
  ssoAppId: "b00ba1c5-be59-4280-9fce-8f35d9af88f6",
  ssoAppIdStaging: "b756b1a1-f58d-4a9f-8e28-f7fe9d795445",
  ssoAppIdTest: "11c3de02-3cdf-477e-a126-09a5dc2325e8",
  ssoAppIdLocal: "11c3de02-3cdf-477e-a126-09a5dc2325e8",
};



// WEBPACK FOOTER //
// ./src/app/constants/appSettings.const.js